import { render, staticRenderFns } from "./SelectTipoDocumento.vue?vue&type=template&id=858c64be&"
import script from "./SelectTipoDocumento.vue?vue&type=script&lang=js&"
export * from "./SelectTipoDocumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports